import clsx from "clsx";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  AppBar,
  Avatar,
  Badge,
  BottomNavigation,
  BottomNavigationAction,
  Chip,
  Divider,
  Drawer,
  IconButton,
  List,
  makeStyles,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  withStyles,
} from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import MenuIcon from "@material-ui/icons/Menu";
import BackdropLoading from "../components/BackdropLoading";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import UserModal from "../components/UserModal";
import { AnimatePresence, motion } from "framer-motion";
import { AuthContext } from "../context/Auth/AuthContext";
import MainListItems from "./MainListItems";
import { MoonStar, Sun, KanbanSquare } from "lucide-react";
import BrightnessAutoIcon from "@material-ui/icons/BrightnessAuto";
import AnnouncementsPopover from "../components/AnnouncementsPopover";
import AnnouncementDisplayModal from "../components/AnnouncementDisplayModal";
import { getBackendUrl } from "../config";
import toastError from "../errors/toastError";
import { useDate } from "../hooks/useDate";
import useSettings from "../hooks/useSettings";
import { i18n } from "../translate/i18n";
import { Link as RouterLink, useLocation, useHistory } from "react-router-dom";
import ColorModeContext from "./themeContext";
import { ChevronRight } from "@material-ui/icons";
import AppListItems from "./AppListItems";
import NotificationsVolume from '../components/NotificationsVolume';
import { LogOutIcon } from "lucide-react";
import { MessageCircleMore } from "lucide-react";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import useVersion from "../hooks/useVersion";
import VersionControl from "../components/VersionControl";
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import AirplanemodeInactiveTwoToneIcon from '@material-ui/icons/AirplanemodeInactiveTwoTone';
import AppsIcon from '@material-ui/icons/Apps';
import PersonIcon from '@material-ui/icons/Person';
import ApartmentIcon from '@material-ui/icons/Apartment';
import ChatIcon from '@material-ui/icons/Chat';
import HomeIcon from '@material-ui/icons/Home';
import ContactPhoneOutlinedIcon from '@material-ui/icons/ContactPhoneOutlined';
import QuestionAnswerOutlinedIcon from '@material-ui/icons/QuestionAnswerOutlined';
import api from "../services/api";
import * as sw from "../serviceWorker";

import {
  AllInclusive,
  AttachFile,
  DeviceHubOutlined,
  PhonelinkSetup,
} from "@material-ui/icons";
import { Ri24HoursFill } from "react-icons/ri";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import { ShapeLine, Webhook } from "@mui/icons-material";
import ChangelogBadgeButton from "../components/Changelog/ChangelogBadgeButton";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import BusinessIcon from "@material-ui/icons/Business";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import ListIcon from "@material-ui/icons/ListAlt";
import PeopleIcon from "@material-ui/icons/People";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import Description from "@material-ui/icons/Description";
import GridOn from "@material-ui/icons/GridOn";
import Schedule from "@material-ui/icons/Schedule";
import HistoryIcon from "@material-ui/icons/History";


const backendUrl = getBackendUrl();
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  height: "100vh",
    backgroundColor: theme.palette.fancyBackground,
    "& .MuiButton-outlinedPrimary": {
      color: theme.palette.primary,
      border:
        theme.mode === "light"
          ? "1px solid rgba(0 124 102)"
          : "1px solid rgba(187, 51, 51, 0.5)",
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: theme.palette.primary,
    },
  },
  chip: {
    background: "red",
    color: "white",
  },
  avatar: {
    width: "100%",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    color: theme.palette.dark.main,
    background: theme.palette.barraSuperior,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // backgroundColor: "#FFF",
    backgroundSize: "cover",
    padding: "0 8px",
    minHeight: "48px",
    [theme.breakpoints.down("sm")]: {
      height: "48px",
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    // [theme.breakpoints.down("sm")]: {
    //   display: "none",
    // },
  },
  // menuButton: {
  //   marginRight: 36,
  // },
  menuButtonHidden: {
    display: "none",
  },
  containerMenuButton: {
  width: "100%",
  height: "37px",
  backgroundColor: "#FAFAFA",
  position: "fixed",
  zIndex: 99,
  display: "none", // passa a não exibir no mobile pois teremos bottom nav
  },
  menuButton: {
    color: "black",
    display: "block",
    marginLeft: 5,
  },
  title: {
    flexGrow: 1,
    fontSize: 14,
    color: "white",
    marginLeft: 10,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    // overflowX: "hidden",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
    overflowY: "hidden",
  },

  drawerPaperClose: {
    overflowX: "hidden",
    overflowY: "hidden",
    height: "100dvh",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: "72px",
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },

  appBarSpacer: {
  minHeight: 48,
  },
  appBarSpacerVertical: {
  minHeight: 0,
  },
  content: {
    flex: 1,
  overflow: "auto",
    // o paddingBottom será aplicado inline de forma dinâmica
  },
  bottomNav: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    borderTop: `1px solid rgba(0,0,0,0.1)`,
    zIndex: 1201, // acima do conteúdo, abaixo de possíveis modais
    // Espaço extra inferior para afastar da barra de gestos + safe-area
    paddingBottom: 10,
    // Safe-area lateral para iPhones com notch (ex.: XR)
    paddingLeft: 8,
    paddingRight: 8,
    "@supports (padding-left: env(safe-area-inset-left))": {
      paddingLeft: "calc(8px + env(safe-area-inset-left))",
      paddingRight: "calc(8px + env(safe-area-inset-right))",
    },
    "@supports (padding-left: constant(safe-area-inset-left))": {
      paddingLeft: "calc(8px + constant(safe-area-inset-left))",
      paddingRight: "calc(8px + constant(safe-area-inset-right))",
    },
    "@supports (padding-bottom: env(safe-area-inset-bottom))": {
      paddingBottom: "calc(12px + env(safe-area-inset-bottom))",
    },
    "@supports (padding-bottom: constant(safe-area-inset-bottom))": {
      paddingBottom: "calc(12px + constant(safe-area-inset-bottom))",
    },
  // Padrão mobile: xs e sm
  [theme.breakpoints.down("sm")]: {
      minHeight: 64,
      "& .MuiBottomNavigationAction-root": {
        minWidth: "unset",
  padding: "10px 12px",
  flex: 1, // distribuir uniformemente
  justifyContent: 'center',
      },
      "& .MuiBottomNavigationAction-label": {
  // Ocultar texto no mobile
  display: 'none',
      },
      "& .Mui-selected .MuiBottomNavigationAction-label": {
  // Garantir oculto mesmo selecionado
  display: 'none',
      },
      // Aumenta o tamanho dos ícones no mobile (atinge MUI e SVGs genéricos)
      "& .MuiBottomNavigationAction-root svg": {
        width: 28,
        height: 28,
      },
    },
  },
  // Container de alertas no mobile (atualização e conexões)
  mobileAlerts: {
    position: "fixed",
    left: 0,
    right: 0,
    zIndex: 1300,
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 8,
    },
    paddingLeft: 8,
    paddingRight: 8,
    "@supports (padding-left: env(safe-area-inset-left))": {
      paddingLeft: "calc(8px + env(safe-area-inset-left))",
      paddingRight: "calc(8px + env(safe-area-inset-right))",
    },
    "@supports (padding-left: constant(safe-area-inset-left))": {
      paddingLeft: "calc(8px + constant(safe-area-inset-left))",
      paddingRight: "calc(8px + constant(safe-area-inset-right))",
    },
  },
  mobilePill: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#e53935",
    color: "#fff",
    fontSize: "0.8125rem", // ~13px
    lineHeight: 1,
    padding: "8px 12px",
    borderRadius: 18,
    fontWeight: 600,
    boxShadow: "0 2px 8px 0 rgba(229,57,53,0.10)",
    whiteSpace: "nowrap",
    height: 36,
    cursor: "pointer",
    gap: 6,
  },
  mobileAlertChip: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgba(78, 228, 18, 0.9)",
    color: "#fff",
    fontSize: "0.8125rem",
    lineHeight: 1,
    padding: "8px 12px",
    borderRadius: 18,
    fontWeight: 600,
    boxShadow: "0 2px 8px 0 rgba(78,228,18,0.12)",
    whiteSpace: "nowrap",
    height: 36,
    cursor: "pointer",
    gap: 6,
  },
  // Oculta o texto do rótulo em uma ação específica do BottomNavigation
  bottomActionNoLabel: {
    '& .MuiBottomNavigationAction-label': {
      display: 'none',
    },
  },
  // Oculta labels de todas ações no mobile
  bottomActionsHideLabelsMobile: {
    [theme.breakpoints.down('sm')]: {
      '& .MuiBottomNavigationAction-label': {
        display: 'none',
      },
      '& .Mui-selected .MuiBottomNavigationAction-label': {
        display: 'none',
      },
    },
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  containerWithScroll: {
    flex: 1,
    // padding: theme.spacing(1),
    overflowY: "scroll", // Use "auto" para mostrar a barra de rolagem apenas quando necessário
    overflowX: "hidden", // Oculta a barra de rolagem horizontal
    ...theme.scrollbarStyles,
    borderRadius: "8px",
    border: "2px solid transparent",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    "scrollbar-width": "none",
  },
  NotificationsPopOver: {
    // color: theme.barraSuperior.secondary.main,
  },
  logo: {
    width: "100%",
    height: "45px",
    maxWidth: 180,
    maxHeight: 45,
    objectFit: "contain", // Garante proporção
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      height: "100%",
      maxWidth: 180,
      maxHeight: 45,
      objectFit: "contain",
    },
    logo: theme.logo,
    content:
      "url(" +
      (theme.mode === "light"
        ? theme.calculatedLogoLight()
        : theme.calculatedLogoDark()) +
      ")",
  },
  hideLogo: {
    display: "none",
  },
  avatar2: {
    width: "42px",
    height: "42px",
    cursor: "pointer",
    borderRadius: "50%",
    border: "2px solid #ccc",
  },
  updateDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  hideSideBar: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  hideTopBar: {
    display: "none",
  },
}));

const StyledBadge = withStyles((theme) => ({
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const SmallAvatar = withStyles((theme) => ({
  root: {
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`,
  },
}))(Avatar);

// Constantes nomeadas para índices de menu
const MENU_SETTINGS = "settings";
const MENU_PROFILE = "profile";

const LoggedInLayout = ({ children, themeToggle }) => {
  const classes = useStyles();
  const [userToken, setUserToken] = useState("disabled");
  const [loadingUserToken, setLoadingUserToken] = useState(false);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, socket, handleLogout, loading, isHorizontal, setIsHorizontal } =
    useContext(AuthContext);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVariant, setDrawerVariant] = useState("permanent");
  const [activeButton, setActiveButton] = useState(null);
  const theme = useTheme();
  const { colorMode } = useContext(ColorModeContext);
  const greaterThenSm = useMediaQuery(theme.breakpoints.up("sm"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const location = useLocation();
  const history = useHistory();
  // Inicializa selectedSubMenu como objeto
  const [selectedSubMenu, setSelectedSubMenu] = useState({});
  // Volume de notificações: inicia com localStorage (numérico) ou 0.33; persiste default se ausente
  const initialStoredVolume = localStorage.getItem("volume");
  const initialVolume = (() => {
    if (initialStoredVolume === null || initialStoredVolume === "") {
      return 0.33;
    }
    const v = Number(initialStoredVolume);
    if (!Number.isFinite(v)) return 0.33;
    return Math.min(1, Math.max(0, v));
  })();
  if (initialStoredVolume === null || initialStoredVolume === "") {
    try { localStorage.setItem("volume", String(initialVolume)); } catch (_) {}
  }
  const [volume, setVolume] = useState(initialVolume);
  const { dateToClient } = useDate();
  const [profileUrl, setProfileUrl] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const mainListItems = useMemo(
    () => <MainListItems drawerOpen={drawerOpen} collapsed={!drawerOpen} />,
    [user, drawerOpen]
  );

  const [version, setVersion] = useState(false);
  const { getVersion } = useVersion();

  const { whatsApps } = useContext(WhatsAppsContext);

  const [connectionWarning, setConnectionWarning] = useState(false);

  // -- Utilitário: injetar metas e patch de manifest com o nome do app (WL)
  function ensureBrandingRuntime(appNameValue) {
    try {
      const name = (appNameValue || "").trim();
      if (!name) return;
      const setMeta = (n, v) => {
        let el = document.querySelector(`meta[name="${n}"]`);
        if (!el) { el = document.createElement("meta"); el.setAttribute("name", n); document.head.appendChild(el); }
        el.setAttribute("content", v);
      };
      setMeta("application-name", name);
      setMeta("apple-mobile-web-app-title", name);
      try { document.title = name; } catch {}
      const link = document.querySelector('link[rel="manifest"]');
      if (link && link.href) {
        fetch(link.href)
          .then(r => r.json())
          .then(man => {
            const patched = { ...man, name, short_name: name };
            const blob = new Blob([JSON.stringify(patched)], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            link.href = url;
          }).catch(() => {});
      }
    } catch (_) {}
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  useEffect(() => {
    async function fetchVersion() {
      const _version = await getVersion();
      setVersion(_version.version);
    }
    fetchVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const settings = useSettings();
  const { getPublicSetting } = useSettings();

  useEffect(() => {
    const getSetting = async () => {
      const response = await settings.get("wtV");

      if (response) {
        setUserToken("disabled");
      } else {
        setUserToken("disabled");
      }
    };

    getSetting();
  });

  // 1) Checagem de sessão: roda só uma vez ao montar o layout
// roda apenas no mount do layout
// roda apenas UMA vez ao montar o layout
// roda apenas uma vez ao montar o layout
// (Removido bloco inválido que retornava JSX dentro de useEffect relacionado ao ChangelogProvider)

  // Branding dinâmico: usa o Nome do Sistema (WL) público, não o nome da empresa do usuário
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const name = await getPublicSetting("appName");
        if (!cancelled && name) ensureBrandingRuntime(name);
      } catch {}
    };
    load();
    return () => { cancelled = true; };
  }, [getPublicSetting]);


// efeito separado para abrir/fechar drawer
useEffect(() => {
  if (document.body.offsetWidth > 600) {
    setDrawerOpen(user.defaultMenu === "closed" ? false : true);
  }
}, [user.defaultMenu]);

// efeito separado para tema
// Tema pós-login (Option B): aplica tema do usuário; se não houver, define 'auto' e persiste 1x
useEffect(() => {
  if (!user?.id) return;
  try {
    const valid = ["light", "dark", "auto"]; 
    const saved = user?.defaultTheme;
    if (saved && valid.includes(saved)) {
      if (colorMode && typeof colorMode.applyThemeChoice === "function") {
        colorMode.applyThemeChoice(saved);
      }
    } else {
      // Aplica auto localmente
      if (colorMode && typeof colorMode.applyThemeChoice === "function") {
        colorMode.applyThemeChoice("auto");
      }
      // Persiste em background somente uma vez por usuário
      const onceKey = `theme:default:persisted:auto:${user.id}`;
      if (!localStorage.getItem(onceKey)) {
        localStorage.setItem(onceKey, "1");
        try { api.put(`/users/${user.id}`, { defaultTheme: "auto" }).catch(() => {}); } catch {}
      }
    }
  } catch (_) {}
  // Executa apenas quando o usuário mudar
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [user?.id]);




  useEffect(() => {
    if (document.body.offsetWidth < 600) {
      setDrawerVariant("temporary");
    } else {
      setDrawerVariant("permanent");
    }
  }, [drawerOpen]);

  useEffect(() => {
    const companyId = user.companyId;
    const userId = user.id;
    if (companyId) {
      //    const socket = socketManager.GetSocket();

      const ImageUrl = user.profileImage;
      if (ImageUrl !== undefined && ImageUrl !== null)
        setProfileUrl(
          `${backendUrl}/public/company${companyId}/user/${ImageUrl}`
        );
      else setProfileUrl(`${process.env.FRONTEND_URL}/nopicture.png`);

      const onCompanyAuthLayout = (data) => {
        if (data.user.id === +userId) {
          toastError("Sua conta foi acessada em outro computador.");
          setTimeout(() => {
            localStorage.clear();
            window.location.reload();
          }, 1000);
        }
      };

      socket.on(`company-${companyId}-auth`, onCompanyAuthLayout);

      socket.emit("userStatus");
      const interval = setInterval(() => {
        socket.emit("userStatus");
      }, 1000 * 120); //status do usuário online de 5 para 2 min.

      return () => {
        socket.off(`company-${companyId}-auth`, onCompanyAuthLayout);
        clearInterval(interval);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket]);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenUserModal = () => {
    // Fecha quaisquer menus/âncoras antes de abrir o modal
    setMenuOpen(false);
    setAnchorEl(null);
    setActiveButton(null);
    setSubmenuAnchorEl(null);
    setUserModalOpen(true);
  };

  const handleClickLogout = () => {
    handleCloseMenu();
    handleLogout();
  };

  const drawerClose = () => {
    if (document.body.offsetWidth < 600 || user.defaultMenu === "closed") {
      setDrawerOpen(false);
    }
  };

  const handleRefreshPage = () => {
    window.location.reload(false);
  };

  // Bottom Navigation: estado e sincronização com rota (precisa vir antes de qualquer early return)
  const [bottomValue, setBottomValue] = useState(0);
  const [bottomNavHeight, setBottomNavHeight] = useState(56);

  // Itens do bottom nav (dinâmicos conforme permissão)
  const bottomItems = useMemo(() => {
    const items = [];
    // Usuário: sempre visível, primeiro item (abre o mesmo menu do AppBar)
    items.push({ key: "userMenu", label: "Usuário", icon: (
      <Avatar src={profileUrl} style={{ width: 28, height: 28 }} />
    ), type: "user-menu" });
    if (user?.profile === "admin") {
      // Ícone de grid igual ao do AppBar para abrir o menu de configurações
      items.push({ key: "menu", label: "Configurações", icon: <AppsIcon />, type: "menu" });
    }
    // Ordem solicitada: contacts > kanban > tasks > chats > tickets
    items.push(
      { key: "contacts", label: "Contatos", icon: <ContactPhoneOutlinedIcon />, type: "route", to: "/contacts" },
      { key: "kanban", label: "Kanban", icon: <KanbanSquare />, type: "route", to: "/kanban" },
      { key: "tasks", label: "Tarefas", icon: <EventAvailableIcon />, type: "route", to: "/tasks" },
      { key: "chats", label: "Chat interno", icon: <QuestionAnswerOutlinedIcon />, type: "route", to: "/chats" },
      { key: "tickets", label: "Tickets", icon: <MessageCircleMore />, type: "route", to: "/tickets" },
    );
    return items;
  }, [user?.profile, profileUrl]);

  // Seleção baseada na rota atual
  useEffect(() => {
    const p = location.pathname;
    const index = bottomItems.findIndex(it => {
      if (it.type !== "route") return false;
      if (it.key === "tickets") return p.startsWith("/tickets");
      if (it.key === "tasks") return p.startsWith("/tasks") || p.startsWith("/todolist");
      if (it.key === "kanban") return p.startsWith("/kanban");
      return p.startsWith(it.to);
    });
    if (index >= 0) setBottomValue(index);
    else setBottomValue(Math.max(bottomItems.length - 1, 0));
  }, [location.pathname, bottomItems]);

  // Ocultar bottom nav quando uma conversa estiver aberta
  const path = location.pathname;
  const isTicketConversation = /^\/tickets\/[^/]+/.test(path);
  const isChatConversation = /^\/chats\/[^/]+/.test(path);
  const isConversationOpen = isTicketConversation || isChatConversation;
  // Exibir bottom nav em xs e sm; ocultar em md+
  const showBottomNav = !isDesktop && !isConversationOpen;
  const bottomNavRef = useRef(null);
  // Observa a altura real do BottomNavigation para ajustar o padding do conteúdo
  useEffect(() => {
    if (!bottomNavRef.current) return;
    const el = bottomNavRef.current;
    const update = () => {
      const h = el.getBoundingClientRect().height || 56;
      setBottomNavHeight(h);
    };
    update();
    // Observer para mudanças de layout
    const resizeObs = new ResizeObserver(update);
    resizeObs.observe(el);
    // Listener para mudanças de safe-area (rotação, etc.)
    window.addEventListener("resize", update);
    return () => {
      try { resizeObs.disconnect(); } catch {}
      window.removeEventListener("resize", update);
    };
  }, [showBottomNav]);

  // =====================
  // Web Push: assinatura automática no boot/login
  // =====================
  const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || undefined;

  function getDeviceId() {
    const key = "deviceId";
    let v = localStorage.getItem(key);
    if (!v) {
      v = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(key, v);
    }
    return v;
  }

  function urlBase64ToUint8Array(base64String) {
    if (!base64String) return new Uint8Array();
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
  }

  useEffect(() => {
    let cancelled = false;
    const ensure = async () => {
      try {
        if (!user?.id || !VAPID_PUBLIC_KEY) return;
        if (!('Notification' in window) || !('serviceWorker' in navigator)) return;

        if (Notification.permission === 'denied') return;
        if (Notification.permission === 'default') {
          const permission = await Notification.requestPermission();
          if (permission !== 'granted') return;
        }

        await new Promise(r => setTimeout(r, 300));
        const registration = await sw.getServiceWorkerRegistration();
        if (!registration) return;

        const existing = await registration.pushManager.getSubscription();
        const vapidUint8 = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
        const subscription = existing || await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: vapidUint8,
        });
        if (cancelled || !subscription) return;

        const deviceId = getDeviceId();
        const endpoint = subscription.endpoint || '';
        const cacheKey = `webpush:endpoint:${user.id}:${deviceId}:${(VAPID_PUBLIC_KEY || '').slice(0,8)}`;
        const cached = localStorage.getItem(cacheKey);
        if (cached === endpoint) return;

        await api.put(`/setting/webpush:user:${user.id}:${deviceId}`, { value: JSON.stringify(subscription) });
        localStorage.setItem(cacheKey, endpoint);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[WebPush] Falha ao garantir assinatura no boot', e);
      }
    };
    ensure();
    return () => { cancelled = true; };
  }, [user?.id, VAPID_PUBLIC_KEY]);

  // CTA explícito para pedir permissão (necessário em iOS 16.4+ e mais robusto em Android)
  const [showPushCta, setShowPushCta] = useState(false);
  useEffect(() => {
    const canShow = !!user?.id && 'Notification' in window && 'serviceWorker' in navigator && Notification.permission === 'default' && !!VAPID_PUBLIC_KEY;
    setShowPushCta(canShow);
  }, [user?.id, VAPID_PUBLIC_KEY]);

  async function requestPushPermissionAndSubscribe() {
    try {
      if (!('Notification' in window) || !('serviceWorker' in navigator)) return;
      const perm = await Notification.requestPermission();
      if (perm !== 'granted') return;
      const registration = await sw.getServiceWorkerRegistration();
      if (!registration) return;
      const existing = await registration.pushManager.getSubscription();
      const vapidUint8 = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
      const subscription = existing || await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: vapidUint8 });
      if (!subscription) return;
      const deviceId = getDeviceId();
      const endpoint = subscription.endpoint || '';
      const cacheKey = `webpush:endpoint:${user.id}:${deviceId}:${(VAPID_PUBLIC_KEY || '').slice(0,8)}`;
      const cached = localStorage.getItem(cacheKey);
      if (cached !== endpoint) {
        await api.put(`/setting/webpush:user:${user.id}:${deviceId}`, { value: JSON.stringify(subscription) });
        localStorage.setItem(cacheKey, endpoint);
      }
      setShowPushCta(false);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[WebPush] Falha no CTA de permissão', e);
    }
  }

  if (loading) {
    return <BackdropLoading />;
  }

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveButton(null);
  };

  const toggleDrawer = (open) => (event) => {
    // Verifica se o clique é fora do drawer (não é um clique no próprio drawer ou nas teclas ESC/Enter)
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setIsDrawerOpen(open);
  };

  const handleSubmenuOpen = (event) => {
    setSubmenuAnchorEl(event.currentTarget);
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchorEl(null);
  };

  // Otimiza funções de menu/submenu para usar constantes
  const handleMenuClick = (event, menuKey) => {
    // impede abertura do menu de configurações para não-admin
    if (menuKey === MENU_SETTINGS && user?.profile !== "admin") {
      return;
    }
    setAnchorEl(event.currentTarget);
    setActiveButton(menuKey);
  };

  const handleSubMenuClick = (submenu, menuKey) => {
    setSelectedSubMenu({ [menuKey]: submenu });
    handleMenuClose();
  };

  // =====================
  // Web Push: assinatura automática no boot/login
  // =====================
  

  return (
    <div className={classes.root}>
  {/* Drawer removido em todas as resoluções conforme novo padrão */}
    {isDesktop && (
    <AppBar
        position="absolute"
        className={clsx(
          classes.appBar,
          // drawerOpen && classes.appBarShift,
      !isHorizontal && isDesktop && classes.hideTopBar
        )}
        color="primary"
      >
        <Toolbar variant="dense" className={classes.toolbar}>
          <img className={classes.logo} alt="logo" />
          <Typography
            component="h2"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
          </Typography>
          <AppListItems volume={volume} setVolume={setVolume} />
          {userToken === "enabled" && user?.companyId === 1 && (
            <Chip
              className={classes.chip}
              label={i18n.t("mainDrawer.appBar.user.token")}
            />
          )}

          <div className={classes.versionControlWrapper}>
            <VersionControl />
          </div>

          {connectionWarning && (
            <>
              <Tooltip
                title={user.profile === "admin"
                  ? "Clique para acessar a página de conexões e resolver o problema. Somente administradores podem gerenciar conexões."
                  : "Atenção: Apenas administradores podem acessar a página de conexões para resolver este problema. Caso persista, contate um administrador."}
                arrow
                placement="bottom"
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: "#e53935",
                    color: "#fff",
                    fontSize: "13px",
                    padding: "4px 14px",
                    borderRadius: "50px",
                    fontWeight: 600,
                    boxShadow: "0 2px 8px 0 rgba(229,57,53,0.10)",
                    whiteSpace: "nowrap",
                    cursor: user.profile === "admin" ? "pointer" : "default",
                  }}
                  onClick={() => {
                    if (user.profile === "admin") {
                      history.push("/connections");
                    }
                  }}
                  tabIndex={0}
                  onKeyDown={e => {
                    if (user.profile === "admin" && (e.key === "Enter" || e.key === " ")) {
                      history.push("/connections");
                    }
                  }}
                  role={user.profile === "admin" ? "button" : undefined}
                  aria-label={user.profile === "admin" ? "Ir para página de conexões" : undefined}
                >
                  <AirplanemodeInactiveTwoToneIcon
                    style={{
                      color: "#fff",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                  <span>Verifique as conexões</span>
                </span>
              </Tooltip>
            </>
          )}
          {/* Botão de Novidades & Roadmap + Sino de anúncios */}
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <ChangelogBadgeButton />
            <AnnouncementsPopover />
          </div>

          {/* Menu Setting */}
          {user.profile === "admin" && (
            <Tooltip title={i18n.t("appBarListem.settings")}> 
              <IconButton
                color="inherit"
                size="small"
                onClick={(event) => handleMenuClick(event, MENU_SETTINGS)}
                aria-label="Abrir menu de configurações"
                className={classes.settingsButton}
              >
                <AppsIcon style={{ width: "30px", height: "25px", color: theme.mode === "light" ? "#fff" : undefined }} />
                <AnimatePresence>
                  {selectedSubMenu[MENU_SETTINGS] && (
                    <motion.span
                      key="submenu-1"
                      initial={{ width: 0, opacity: 0 }}
                      animate={{ width: "auto", opacity: 1 }}
                      exit={{ width: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className={classes.settingsSubMenuText}
                    >
                      {selectedSubMenu[MENU_SETTINGS]}
                    </motion.span>
                  )}
                </AnimatePresence>
              </IconButton>
            </Tooltip>
          )}
          {/* Avatar e modal do usuário (gatilho do menu) */}
          <div>
            <Tooltip title={i18n.t("appBarListem.profile")}>
              <StyledBadge
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                variant="dot"
                onClick={handleMenu}
                style={{ marginLeft: "8px" }}
              >
                <Avatar className={classes.avatar2} src={profileUrl} />
              </StyledBadge>
            </Tooltip>
          </div>
        </Toolbar>
  </AppBar>
  )}
  {/* UserModal fora do AppBar para funcionar também no mobile */}
  <UserModal
    open={userModalOpen}
    onClose={() => setUserModalOpen(false)}
    onImageUpdate={(newProfileUrl) => setProfileUrl(newProfileUrl)}
    userId={user?.id}
  />
  {/* Menus fora do AppBar para funcionarem no mobile */}
  {user.profile === "admin" && (
    <Menu
  // Centralizado no mobile; comportamento original no desktop
  anchorEl={isDesktop ? anchorEl : null}
  anchorReference={isDesktop ? 'anchorEl' : 'anchorPosition'}
  anchorPosition={!isDesktop ? { top: Math.round(window.innerHeight / 2), left: Math.round(window.innerWidth / 2) } : undefined}
  keepMounted
  getContentAnchorEl={null}
  open={activeButton === MENU_SETTINGS}
  onClose={handleMenuClose}
  anchorOrigin={isDesktop ? { vertical: 'bottom', horizontal: 'center' } : { vertical: 'center', horizontal: 'center' }}
  transformOrigin={isDesktop ? { vertical: 'top', horizontal: 'center' } : { vertical: 'center', horizontal: 'center' }}
      PaperProps={{
        style: {
          overflow: "hidden",
          maxHeight: "auto",
          padding: 0,
        },
      }}
    >
      {/* Seção exclusiva mobile: atalhos principais */}
      {!isDesktop && (
          <React.Fragment>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                margin: "-5px 5px",
              }}
            >
              {[ 
                { to: "/schedules", icon: <Schedule />, text: "Agendamentos" },
                { to: "/", icon: <DashboardOutlinedIcon />, text: "Dashboard" },
                { to: "/reports", icon: <Description />, text: "Relatórios" },
                { to: "/moments", icon: <GridOn />, text: "Painel de Atendimentos" },
              ].map((item, index) => (
                <MenuItem
                  key={index}
                  component={RouterLink}
                  to={item.to}
                  onClick={() => {
                    handleMenuClose();
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "8px",
                    width: "auto",
                    maxWidth: "95px",
                    minWidth: "85px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "23px",
                      height: "30px",
                      width: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {item.icon}
                  </div>
                  <span
                    style={{
                      fontSize: "12px",
                      marginTop: "6px",
                      textAlign: "center",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      maxWidth: "85px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.text}
                  </span>
                </MenuItem>
              ))}
            </div>
            <div
              style={{
                borderTop: "1px solid #ccc",
                margin: "5px 25px 5px 25px",
              }}
            ></div>
          </React.Fragment>
        )}
      {/* Primeira seção */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          margin: "-5px 5px",
        }}
      >
        {[
          { to: "/NotifyMe", icon: <Ri24HoursFill />, text: "Equipe de plantão" },
          { to: "/quick-messages", icon: <FlashOnIcon />, text: "Respostas Rápidas" },
          { to: "/tags", icon: <LocalOfferIcon />, text: "Tags" },
          { to: "/phrase-lists", icon: <EventAvailableIcon />, text: "Fluxo de campanhas" },
          { to: "/flowbuilders", icon: <ShapeLine />, text: "Fluxo de conversa" },
          { to: "/queue-integration", icon: <DeviceHubOutlined />, text: "Integrações" },
          { to: "/files", icon: <AttachFile />, text: "Lista de arquivos" },
          { to: "/campaigns", icon: <ListIcon />, text: "Campanhas" },
        ].map((item, index) => (
          <MenuItem
            key={index}
            component={RouterLink}
            to={item.to}
            onClick={() => {
              handleMenuClose();
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              padding: "8px",
              width: "auto",
              maxWidth: "95px",
              minWidth: "85px",
            }}
          >
            <div
              style={{
                fontSize: "23px",
                height: "30px",
                width: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {item.icon}
            </div>
            <span
              style={{
                fontSize: "12px",
                marginTop: "6px",
                textAlign: "center",
                whiteSpace: "normal",
                wordWrap: "break-word",
                maxWidth: "85px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item.text}
            </span>
          </MenuItem>
        ))}
      </div>

      {/* Linha divisória */}
      <div
        style={{
          borderTop: "1px solid #ccc",
          margin: "5px 25px 5px 25px",
        }}
      ></div>

      {/* Segunda seção */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          margin: "-5px 5px",
        }}
      >
        {[
          { to: "/settings", icon: <SettingsOutlinedIcon />, text: "Configuração" },
          { to: "/queues", icon: <AccountTreeOutlinedIcon />, text: "Filas e Setores" },
          { to: "/users", icon: <PeopleAltOutlinedIcon />, text: "Usuários" },
          { to: "/connections", icon: <DeviceHubIcon />, text: "Conexões" },
          { to: "/prompts", icon: <AllInclusive />, text: "ChatGPT" },
          { to: "/financeiro", icon: <LocalAtmIcon />, text: "Financeiro" },
          { to: "/announcements", icon: <AnnouncementIcon />, text: "Informativos", isNew: true },
        ]
          .filter(Boolean)
          .map((item, index) => (
            <MenuItem
              key={index}
              component={RouterLink}
              to={item.to}
              onClick={() => {
                handleMenuClose();
              }}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "8px",
                width: "auto",
                maxWidth: "95px",
                minWidth: "85px",
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  height: "30px",
                  width: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {item.icon}
              </div>
              <span
                style={{
                  fontSize: "12px",
                  marginTop: "5px",
                  textAlign: "center",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  maxWidth: "85px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.text}
              </span>
              {item.isNew && (
                <React.Fragment>
                  <style>{`@keyframes pulse{0%{transform:scale(1);opacity:1}50%{transform:scale(1.05);opacity:.8}100%{transform:scale(1);opacity:1}}`}</style>
                  <Chip
                    label="Nova função"
                    size="small"
                    style={{
                      backgroundColor: '#4caf50',
                      color: 'white',
                      fontSize: '9px',
                      fontWeight: 'normal',
                      height: '18px',
                      marginTop: '3px',
                      animation: 'pulse 2s infinite'
                    }}
                  />
                </React.Fragment>
              )}
            </MenuItem>
          ))}
      </div>

      {/* Linha divisória */}
      {user?.super === true && (
        <div
          style={{
            borderTop: "1px solid #ccc",
            margin: "5px 25px 5px 25px",
          }}
        ></div>
      )}

      {/* Terceira seção */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          margin: "-5px 5px",
        }}
      >
        {[
          user.super && { to: "/allConnections", icon: <PhonelinkSetup />, text: "Gerenciar conexões" },
          user.super && { to: "/companies", icon: <BusinessIcon />, text: "Empresas" },
          user.super && { to: "/releases-admin", icon: <HistoryIcon />, text: "Releases" },
        ]
          .filter(Boolean)
          .map((item, index) => (
            <MenuItem
              key={index}
              component={RouterLink}
              to={item.to}
              onClick={() => {
                handleMenuClose();
              }}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "8px",
                width: "auto",
                maxWidth: "95px",
                minWidth: "85px",
              }}
            >
              <div
                style={{
                  fontSize: "25px",
                  height: "30px",
                  width: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {item.icon}
              </div>
              <span
                style={{
                  fontSize: "12px",
                  marginTop: "5px",
                  textAlign: "center",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  maxWidth: "85px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.text}
              </span>
            </MenuItem>
          ))}
      </div>
    </Menu>
  )}

  <Menu
    id="menu-appbar"
  // Centralizado no mobile; comportamento ancorado original no desktop
  anchorEl={isDesktop ? anchorEl : null}
  anchorReference={isDesktop ? 'anchorEl' : 'anchorPosition'}
  anchorPosition={!isDesktop ? { top: Math.round(window.innerHeight / 2), left: Math.round(window.innerWidth / 2) } : undefined}
  getContentAnchorEl={null}
  anchorOrigin={isDesktop ? { vertical: 'bottom', horizontal: 'right' } : { vertical: 'center', horizontal: 'center' }}
  transformOrigin={isDesktop ? { vertical: 'top', horizontal: 'right' } : { vertical: 'center', horizontal: 'center' }}
    open={menuOpen}
    onClose={handleCloseMenu}
    PaperProps={{
      style: {
        minWidth: "250px",
        maxWidth: "350px",
        overflow: "hidden",
      },
    }}
  >
    {/* Controle de tema tri-estado: Claro | Auto | Escuro */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "6px 8px",
        userSelect: "none",
      }}
    >
      {(() => {
        const active = (colorMode?.themeChoice || "auto");
        const isDark = theme.mode === "dark";
        const baseBg = isDark ? "rgba(255,255,255,0.10)" : "rgba(0,0,0,0.10)";
        const activeBg = isDark ? "rgba(255,255,255,0.20)" : "rgba(0,0,0,0.15)";
        const borderColor = isDark ? "rgba(255,255,255,0.25)" : "rgba(0,0,0,0.15)";
        const itemStyle = (on, radiusLeft, radiusRight) => ({
          padding: "6px 10px",
          display: "flex",
          alignItems: "center",
          gap: 6,
          cursor: "pointer",
          background: on ? activeBg : "transparent",
          transition: "background .2s ease",
          borderRadius: `${radiusLeft}px ${radiusRight}px ${radiusRight}px ${radiusLeft}px`,
        });
        const iconColor = theme.palette.dark.main;
        const commit = (choice) => {
          if (colorMode && typeof colorMode.applyThemeChoice === 'function') {
            colorMode.applyThemeChoice(choice);
          }
          try { api.put(`/users/${user.id}`, { defaultTheme: choice }).catch(() => {}); } catch {}
        };
        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              background: baseBg,
              borderRadius: 999,
              padding: 2,
              border: `1px solid ${borderColor}`,
            }}
            role="group"
            aria-label="Alternar tema"
          >
            <div
              onClick={() => commit("light")}
              title="Claro"
              style={itemStyle(active === "light", 999, 0)}
            >
              <Sun style={{ color: iconColor, width: 18, height: 18 }} />
            </div>
            <div
              onClick={() => commit("auto")}
              title="Auto"
              style={itemStyle(active === "auto", 0, 0)}
            >
              <BrightnessAutoIcon style={{ color: iconColor, width: 18, height: 18 }} />
            </div>
            <div
              onClick={() => commit("dark")}
              title="Escuro"
              style={itemStyle(active === "dark", 0, 999)}
            >
              <MoonStar style={{ color: iconColor, width: 18, height: 18 }} />
            </div>
          </div>
        );
      })()}
    </div>

    <NotificationsVolume setVolume={setVolume} volume={volume} />
    <Divider style={{ margin: "5px 25px 5px 25px" }} />
    <MenuItem onClick={handleOpenUserModal} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <PeopleAltOutlinedIcon />
      {i18n.t("mainDrawer.appBar.user.profile")}
    </MenuItem>
    <Divider style={{ margin: "5px 25px 5px 25px" }} />
    <MenuItem onClick={handleClickLogout} style={{ display: "auto", alignItems: "center", gap: "8px" }}>
      <LogOutIcon />
      {i18n.t("mainDrawer.appBar.user.logout")}
    </MenuItem>
    <Divider style={{ margin: "5px 25px 5px 25px" }} />
    <Typography
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        margin: "15px 35px 5px 35px",
        fontSize: "12px",
      }}
    >
      <ApartmentIcon style={{ fontSize: "20px" }} />
      {user?.company?.name}
    </Typography>
    <Typography
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        margin: "5px 35px 5px 35px",
        fontSize: "12px",
      }}
    >
      <PersonIcon style={{ fontSize: "20px" }} />
      {user.name}
    </Typography>
    <Divider style={{ margin: "5px 25px 5px 25px" }} />
    <Typography
      style={{
        display: "flex",
        fontSize: "12px",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "4px",
        margin: "5px 35px 5px 35px",
      }}
    >
      {greaterThenSm &&
        user?.profile === "admin" &&
        user?.company?.dueDate ? (
          <>
            Expiração do plano: <b>{dateToClient(user.company.dueDate)}</b>
          </>
        ) : null}
    </Typography>
    <Divider style={{ margin: "5px 25px 5px 25px" }} />
    <Typography>
      <React.Fragment>
        <Typography
          style={{
            fontSize: "10px",
            padding: "10px",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Versão: {`${version}`}
        </Typography>
      </React.Fragment>
    </Typography>
  </Menu>
  <main className={classes.content} style={{ paddingBottom: showBottomNav ? bottomNavHeight : 0 }}>
        <div className={isDesktop ? classes.appBarSpacer : classes.appBarSpacerVertical} />

        {children ? children : null}
      </main>

      {/* Avisos compactos no mobile (acima da Bottom Navigation) */}
      {showBottomNav && (
        <div
          className={classes.mobileAlerts}
          style={{ bottom: bottomNavHeight + 8, flexDirection: 'column' }}
        >
          {/* CTA de push quando necessário */}
          {showPushCta && (
            <span
              className={classes.mobileAlertChip}
              onClick={requestPushPermissionAndSubscribe}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') requestPushPermissionAndSubscribe(); }}
              style={{ marginBottom: connectionWarning ? 8 : 0 }}
            >
              Ativar notificações
            </span>
          )}
          {/* Atualização acima */}
          <div style={{ marginBottom: connectionWarning ? 8 : 0 }}>
            <VersionControl
              alwaysShowText
              tooltipPlacement="top"
              iconSize={18}
              containerStyle={{ width: 'auto', height: 'auto' }}
              chipClassName={classes.mobileAlertChip}
            />
          </div>
          {/* Conexões abaixo */}
          {connectionWarning && (
            <Tooltip
              title={user.profile === "admin"
                ? "Clique para acessar a página de conexões e resolver o problema. Somente administradores podem gerenciar conexões."
                : "Atenção: Apenas administradores podem acessar a página de conexões para resolver este problema. Caso persista, contate um administrador."}
              arrow
              placement="top"
            >
              <span
                className={classes.mobilePill}
                onClick={() => {
                  if (user.profile === "admin") {
                    history.push("/connections");
                  }
                }}
                tabIndex={0}
                onKeyDown={e => {
                  if (user.profile === "admin" && (e.key === "Enter" || e.key === " ")) {
                    history.push("/connections");
                  }
                }}
                role={user.profile === "admin" ? "button" : undefined}
                aria-label={user.profile === "admin" ? "Ir para página de conexões" : undefined}
              >
                <AirplanemodeInactiveTwoToneIcon style={{ color: "#fff", width: 18, height: 18 }} />
                <span>Verifique as conexões</span>
              </span>
            </Tooltip>
          )}
        </div>
      )}

      {/* Bottom Navigation - apenas mobile */}
      {showBottomNav && (
  <BottomNavigation
          ref={bottomNavRef}
          value={bottomValue}
          showLabels={false}
          onChange={(e, newVal) => {
            setBottomValue(newVal);
            const item = bottomItems[newVal];
            if (!item) return;
            if (item.type === "user-menu") {
              // Abre o mesmo menu do AppBar, ancorado na barra inferior
              handleMenu({ currentTarget: bottomNavRef.current });
              return;
            }
            if (item.type === "menu") {
              handleMenuClick({ currentTarget: bottomNavRef.current }, MENU_SETTINGS);
              return;
            }
            history.push(item.to);
          }}
          className={clsx(classes.bottomNav, classes.bottomActionsHideLabelsMobile)}
        >
          {bottomItems.map((it) => (
            <BottomNavigationAction
              key={it.key}
              label={it.label}
              icon={it.icon}
              className={it.key === 'userMenu' ? classes.bottomActionNoLabel : undefined}
              aria-label={it.key === 'userMenu' ? 'Usuário' : undefined}
            />
          ))}
        </BottomNavigation>
      )}
      
      {/* Modal de exibição de anúncios após login */}
      <AnnouncementDisplayModal />
    </div>
  );
};

export default LoggedInLayout;
